import type { ErrorMessageKey } from "./i18n";
import { getLocale, i18n } from "./i18n";
import type { SupportedLocale } from "./translations";

const ERROR_MESSAGE_CLASS = "error-message";
const BLUR_CLASS = "blur";

const COMPACT_ERROR_I18N_KEY: Record<ErrorMessageKey, string> = {
  NO_ACCESS_TOKEN: "ui:error.compact.no_token",
  INVALID_ACCESS_TOKEN: "ui:error.compact.invalid_token",
  STORE_UNAVAILABLE: "ui:error.compact.no_data",
  STORE_CREATION_FAILED: "",
  SOCKET_CONNECTION_FAILED: "ui:error.compact.no_connection",
  SENSECLOUD_CONNECTION_FAILED: "ui:error.compact.no_connection",
  CONTROLLER_CONNECTION_FAILED: "ui:error.compact.no_connection",
  HISTORIC_DATA_FAILED: "ui:error.compact.data_error",
  BACK_DOOR_CHECK_FAILED: "ui:error.compact.data_error",
  CONSOLE_INFO: "ui:error.compact.generic",
};

export const getCompactErrorMessage = (
  messageKey?: ErrorMessageKey,
  locale?: SupportedLocale | string,
): string => {
  const key = messageKey ?? "CONSOLE_INFO";
  const i18nKey = COMPACT_ERROR_I18N_KEY[key] ?? COMPACT_ERROR_I18N_KEY.CONSOLE_INFO;
  return i18n.t(i18nKey, { lng: getLocale(locale) });
};

const removeExistingErrorMessage = (container: HTMLElement) => {
  const existingError = container.querySelector(`.${ERROR_MESSAGE_CLASS}`);
  if (existingError !== null) {
    existingError.remove();
  }
};

export const applyErrorMessage = (container: HTMLElement, message: string) => {
  // Ensure only one overlay message exists at a time.
  removeExistingErrorMessage(container);

  const errorMessageElement = document.createElement("div");
  errorMessageElement.append(message);
  errorMessageElement.classList.add(ERROR_MESSAGE_CLASS);
  container.append(errorMessageElement);

  // Blur all sibling content while keeping the error text crisp.
  Array.from(container.children).forEach((child: Element) => {
    if (!child.classList.contains(ERROR_MESSAGE_CLASS)) {
      child.classList.add(BLUR_CLASS);
      return;
    }

    if (child.classList.contains(ERROR_MESSAGE_CLASS)) {
      child.classList.remove(BLUR_CLASS);
    }
  });
};

export const clearErrorMessage = (container: HTMLElement) => {
  // Restore original visuals and remove the temporary error overlay.
  Array.from(container.children).forEach((child: Element) => {
    if (!child.classList.contains(ERROR_MESSAGE_CLASS)) {
      child.classList.remove(BLUR_CLASS);
    }

    if (child.classList.contains(ERROR_MESSAGE_CLASS)) {
      child.remove();
    }
  });
};
